if (process.env.REACT_APP_SENTRY_ENV !== '') {
  import('@sentry/browser').then(Sentry => Sentry.init({
    dsn: 'https://6fe77cf8fdb9459482c86df6871fc180@sentry.allvision.io/5',
    environment: process.env.REACT_APP_SENTRY_ENV,
    release: process.env.REACT_APP_HASH,
  }));
} else {
  console.info('Sentry is disabled for local development.');
}
